import React, { FC, useCallback, useState } from 'react'
import { useEffectOnce } from 'react-use'
import { Grid, makeStyles } from 'transfix-ui/core'
import { useCarrierMembershipApi } from 'apps/fleet-planner/hooks/useCarrierMembershipApi'
import { useGetDedicatedLanesBids } from 'apps/fleet-planner/types/apiTypes'
import { getLaneBids } from 'apps/fleet-planner/utils/dedicatedLanesHelpers'
import { DedicatedLanesBidCard } from '../DedicatedLanesBidCard'
import DedicatedLanesBidFormBody from './components/DedicatedLanesBidFormBody'
import DedicatedLanesBidFormSkeleton from './components/DedicatedLanesBidFormSkeleton'
import DedicatedLanesInquiryButton from './components/DedicatedLanesInquiryButton'

interface IDedicatedLanesBidFormProps {
  dedicatedLaneId?: number
  dedicatedLaneAvgAmount?: number
}

const useDedicatedLanesBidFormStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(3),
  },
  moreInfoButton: {
    border: 'none',
    '&:focus': {
      outline: 'none',
    },
  },
  bid: {
    paddingBottom: theme.spacing(2),
  },
  formField: {
    marginTop: theme.spacing(2),
  },
}))

export const DedicatedLanesBidForm: FC<IDedicatedLanesBidFormProps> = ({
  dedicatedLaneAvgAmount,
  dedicatedLaneId,
}) => {
  const classes = useDedicatedLanesBidFormStyles()

  const [loading, setLoading] = useState<boolean>(true)

  const {
    userMotorCarriers = [],
    getUserMotorCarriers,
    activeUserMotorCarriers = [],
  } = useCarrierMembershipApi({
    onGetUserMotorCarriersComplete: () => {
      setLoading(false)
    },
  })

  const { data: bidsData, refetch: refetchDedicatedLanesBids } = useGetDedicatedLanesBids({})
  const { dedicatedLanesBids = [] } = bidsData || {}
  const bids = getLaneBids(dedicatedLanesBids, dedicatedLaneId, activeUserMotorCarriers) || []

  const bidSubmitSuccessHandler = useCallback(() => {
    refetchDedicatedLanesBids()
  }, [refetchDedicatedLanesBids])

  useEffectOnce(() => {
    getUserMotorCarriers()
  })

  return (
    <div className={classes.container}>
      {bids.length > 0 && (
        <div>
          {bids.map(bid => (
            <div key={bid.bidId} className={classes.bid}>
              <DedicatedLanesBidCard bid={bid} />
            </div>
          ))}
        </div>
      )}
      {loading && <DedicatedLanesBidFormSkeleton />}
      {!loading && dedicatedLaneId && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DedicatedLanesBidFormBody
              dedicatedLaneId={dedicatedLaneId}
              averageAmount={dedicatedLaneAvgAmount}
              userMotorCarriers={userMotorCarriers}
              onSuccess={bidSubmitSuccessHandler}
            />
          </Grid>
          <Grid item xs={12}>
            <DedicatedLanesInquiryButton dedicatedLaneId={dedicatedLaneId} />
          </Grid>
        </Grid>
      )}
    </div>
  )
}
